import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/exams/$id/languages/' as never)({
  component: ExamLanguagesRedirect,
});

/** Languages are now integrated into the main edit page tabs. */
function ExamLanguagesRedirect() {
  const { id } = (Route as unknown as { useParams: () => { id: string } }).useParams();
  return <Navigate to={'/exams/$id' as never} params={{ id } as never} />;
}
